module.exports = __webpack_public_path__ + "img/mbg.88ceeb88.png";